<template>
  <div class="w-full filternone neg-mt-8">
    <!-- <PartnershipPopup
      :isActive="isDetailsActive"
      :selectedPartnership="selectedPartnership"
      @close="toggleDetails"
    /> -->
    <modal
      :show.sync="isActiveLocal"
      centered
      header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
      modal-content-classes="cust-medi-popup cust-overflow-y-grey"
      hide-footer
      class="overflow-y-hidden"
      @close="isActiveLocal = false"
    >
      <div class="flex justify-between pb-8">
        <div class="my-auto">
          <p class="font-medium text-2xl text-black">
            {{ selectedPartnership.title }}
          </p>
        </div>
        <img
          src="../../../assets/images/cross.png"
          class="h-8 w-8 cursor-pointer"
          alt="cross"
          @click="isActiveLocal = false"
        />
      </div>
      <div class="" v-html="selectedPartnership.description"></div>
      <template slot="footer" class="hidden"> <div></div> </template>
    </modal>
    <div class="relative flex justify-center lg:px-0 md:px-0 px-6">
      <div class="absolute">
        <div class="bg-designGT mob-hidden mb-8">
          <img
            src="../../../assets/images/line/abtus-line-1.svg"
            alt="bg-polygon"
          />
        </div>
      </div>
      <div
        class="relative lg:w-3/4 md:w-3/4 w-full items-center md:py-12 lg:py-12"
      >
        <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden"></div>
        <div class="w-full mt-12">
          <div class="mt-24">
            <p
              class="title text-center sm-fsize25 md:font-normal lg:font-normal font-bold"
            >
              Our Service Offerings
            </p>
          </div>
        </div>
        <div class="mt-8 relative">
          <b-card no-body class="border-none">
            <div class="related-products">
              <swiper
                :options="swiperOption"
                class="related-product-swiper swiperrow_center"
              >
                <swiper-slide
                  v-for="item in allServ"
                  :key="item.objectId"
                  class="border-2 rounded-lg border-none card-radius slider-h slider-w"
                >
                  <b-card class="mb-2 card-radius Border-primary slider-h">
                    <b-card-text class="">
                      <h2 class="fsize25px mb-4">{{ item.title }}</h2>

                      <div
                        class="flex items-center mb-2 w-full"
                        v-for="it in item.subcat"
                        :key="it.objectId"
                      >
                        <CheckIcon size="1.2x" class="mx-1 text-primary w-10" />
                        <p
                          class="fsize18-14 ml-2 w-90"
                          @click="toggleDetails(it)"
                        >
                          {{ it.title }}
                        </p>
                      </div>
                    </b-card-text>
                  </b-card>
                </swiper-slide>

                <div
                  class="swiper-button-prev cust-hidden"
                  slot="button-prev"
                ></div>
                <div
                  class="swiper-button-next cust-hidden"
                  slot="button-next"
                ></div>
              </swiper>
            </div>
            <div class="absolute custom-plant mob-hidden">
              <img src="@/assets/images/Plant.png" alt="plant" class="" />
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//  import "swiper/swiper-bundle.min.css";
import { CheckIcon } from "vue-feather-icons";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
// import PartnershipPopup from "./cg-partnershipPopup.vue";
export default {
  components: {
    swiper,
    swiperSlide,
    CheckIcon,
    // PartnershipPopup,
  },
  data() {
    return {
      selectedPartnership: {},
      isDetailsActive: false,
      isActiveLocal: false,
      swiperOption: {
        slidesPerView: 4,
        observer: true,
        observeParents: true,
        spaceBetween: 20,
        slidesPerColumn: 1,
        slidesPerColumnFill: "row",
        breakpoints: {
          1600: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 55,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 55,
            slidesPerColumn: 1,
          },
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      related_items: [
        {
          name: "Template 1",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 2",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 3",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 4",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 5",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 6",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 7",
          image: require("@/assets/images/logo.png"),
        },
        {
          name: "Template 8",
          image: require("@/assets/images/logo.png"),
        },
      ],
      products: [],

      hasError: false,
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    // selected(item) {
    //   console.log(item);
    // },
    async function() {
      let payload = "testing";
      await this.$store.dispatch("services/getpartner");
      // console.log(this.get_AllPartner);
    },
    image(x) {
      return `${this.$imageURL}/${x}`;
    },
    async toggleDetails(item) {
      // console.log(item);
      this.isActiveLocal = true;
      this.selectedPartnership = item;
    },
  },
  computed: {
    ...mapState("services", { get_AllPartner: "get_AllPartner" }),
    ...mapState("services", { get_AllService: "get_AllService" }),
    allServ() {
      return this.get_AllService.filter((x) => x.subcat.length > 0);
    },
  },
  mounted() {
    this.function();
    this.$store.dispatch("services/get_all");

    // console.log(this.allServ, "ser");
  },
};
</script>

<style lang="scss">
#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .image-div {
    display: flex;
    flex-flow: row;
  }

  .image > img {
    margin: auto 6px;
    height: 60px;
    width: 60px;
  }

  .item-features {
    background-color: #f7f7f7;
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
    // padding-right: 2rem;
    // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1),
          0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(0.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0;
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
.cust-h150px {
  height: 150px;
}
.neg-mt-8 {
  margin-top: -8rem;
}
.swiper-container-multirow > .swiper-wrapper {
  @media (max-width: 576px) {
    flex-wrap: inherit !important;
  }
}
</style>
